import { getUsersMeOrganisationsCurrentSavingsPlansSelector } from "./getUsersMeOrganisationsCurrentSavingsPlansSelector";
import { commitmentsDataGridPayloadDataSelector } from "../payload/commitmentsDataGridPayloadDataSelector";
import { RootState } from "../../../../../store";

export const commitmentsForTableSelector = (state: RootState) => {
  const payload = commitmentsDataGridPayloadDataSelector(state);

  return getUsersMeOrganisationsCurrentSavingsPlansSelector(payload)(state);
};
